import { render, staticRenderFns } from "./xf_list.vue?vue&type=template&id=a59f12a8&scoped=true"
import script from "./xf_list.vue?vue&type=script&lang=js"
export * from "./xf_list.vue?vue&type=script&lang=js"
import style0 from "./xf_list.vue?vue&type=style&index=0&id=a59f12a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59f12a8",
  null
  
)

export default component.exports